module.exports = __webpack_public_path__ + "media/images/fuze-1433e7df56472f1717c544da6c43e464.svg";